import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ThumbsUpStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M1.25 19.5V11.5C1.25 10.5335 2.03352 9.75 3 9.75H7C7.41421 9.75 7.75 10.0858 7.75 10.5C7.75 10.9142 7.41421 11.25 7 11.25H3C2.86192 11.25 2.75 11.3619 2.75 11.5V19.5C2.75 19.638 2.86197 19.75 3 19.75H7C7.41421 19.75 7.75 20.0858 7.75 20.5C7.75 20.9142 7.41421 21.25 7 21.25H3C2.03345 21.25 1.25 20.4664 1.25 19.5Z"
				fill="currentColor"
			/>
			<path
				d="M13.916 2.74997C14.1163 2.75003 14.3084 2.83017 14.4492 2.97263L14.5205 3.04489C16.1828 4.72768 16.6473 7.26902 15.6943 9.43942L15.5576 9.74997H20.0225C21.9121 9.75001 23.2106 11.6311 22.5967 13.4062L20.5215 19.4062C20.1411 20.5058 19.1113 21.25 17.9473 21.25L7 21.25C6.58579 21.25 6.25 20.9142 6.25 20.5V10.5C6.25001 10.3026 6.32811 10.113 6.4668 9.97263L13.3818 2.97263L13.4971 2.8779C13.62 2.79519 13.7657 2.74995 13.916 2.74997ZM7.75 10.8076V19.75H17.9473C18.4623 19.75 18.9289 19.4202 19.1035 18.916L21.1787 12.916C21.4642 12.0904 20.8552 11.25 20.0225 11.25H14.4102C14.157 11.25 13.9207 11.1221 13.7822 10.9101C13.6437 10.6981 13.6208 10.4301 13.7227 10.1982L14.3213 8.83688C14.9384 7.43149 14.7522 5.81771 13.8789 4.60349L7.75 10.8076Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ThumbsUpStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ThumbsUpStrokeIcon;
